/** 根据一维数组权限，生成树状结构数据菜单
 * @params {Array} arr 一维权限数组
 * @return {Array} 返回树状结构菜单
 **/
export function generateMenuTreeStruct(arr) {
  if (arr instanceof Array) {
    for (let i = 0; i < arr.length; i++) {
      let ele = arr[i];

      if (ele.type == 2 || ele.hidden) {
        // 如果当前类型是按钮或者有hidden属性‐不添加到菜单里
        arr.splice(i, 1);
        i--;
        continue;
      }
      const pid = ele.pid;

      if (typeof pid !== "undefined" && pid !== null) {
        // 不是根元素
        for (let innerIndex = 0, len = arr.length; innerIndex < len; innerIndex++) {
          const innerEle = arr[innerIndex];

          if (innerEle.id === pid) {
            if (!innerEle.children) {
              innerEle.children = [];
            }

            innerEle.children.push(ele);
            break;
          }
        }
      }
    }
    return arr.filter((ele) => typeof ele.pid === "undefined" || ele.pid === null);
  }
}
/** 根据后端权限返回菜单所需数据
 * @params {Array} permission 权限数组
 * @params {String} appCode 应用标识
 * @return {Array} 返回菜单
 **/

export function permissionMenu(permission, appCode) {
  let menuList = [];

  let menuArr = JSON.parse(JSON.stringify(permission));

  menuArr.forEach((module) => {
    module.webLink = `/subview/${appCode}${module.webLink}`;
  });

  let childrenMenu = generateMenuTreeStruct(menuArr);

  menuList.push(...childrenMenu);
  menuList = sortMenu(menuList);
  return menuList;
}

/** 菜单排序
 *
 */
export function sortMenu(arr) {
  arr.forEach((item) => {
    if (item.children && item.children.length) {
      sortMenu(item.children);
    }
  });

  arr.sort((a, b) => {
    return a.sort - b.sort;
  });
  return arr;
}



// WEBPACK FOOTER //
// ./src/utils/menu.js